import { MatDateFormats } from '@angular/material/core';

// Équivalent date-fns de MAT_MOMENT_DATE_FORMATS_FR (tokens date-fns, pas Moment).
export const MAT_DATE_FNS_DATE_FORMATS_FR: MatDateFormats = {
  parse: {
    dateInput: 'dd/MM/yyyy',
  },
  display: {
    dateInput: 'dd/MM/yyyy',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'd MMMM yyyy',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};
